// HTTP STUFF

export interface HttpResponse<T> {
	response: any;
	data: PaginatedData<T>;
}
export interface PaginatedData<T> {
	data: T[];
	paging: Paging;
}

export interface Paging {
	total: number;
	offset: number;
	limit: number;
}

// CAD

export interface CustomAttributesListPayload {
	data: CustomAttributeDefinition[];
	paging: Paging;
}

interface User {
	id: string;
	userName: string;
}

export interface CustomAttributeDefinition {
	id: string;
	type: CAD_TYPES;
	label: string;
	description: string | null;
	values: string[] | string | null;
	mandatory: boolean;
	defaults: string[] | null;
	createdAt: number;
	createdBy: User;
	updatedAt: number;
	updatedBy: User;
}

export interface CustomAttributeForm {
	id: string;
	type: CAD_TYPES;
	label: string;
	description: string | null;
	values?: string[];
	mandatory: boolean;
	defaults: string | null;
	createdAt: number;
	createdBy: User;
	updatedAt: number;
	updatedBy: User;
}

export type CADFormModel = {
	mandatory: boolean;
	type: CAD_TYPES;
	label?: string;
	description?: string | null;
	defaults?: string | null;
	values?: string[];
};

export enum CAD_TYPES {
	TEXT = 'text',
	LIST_OF_VALUES = 'enum',
}

export enum FORM_MODE {
	ADD = 'Add',
	EDIT = 'Edit',
	READ = 'Read',
}

export type CadReduxAction = {
	type: string;
	payload?: any;
	cmf?: any;
};
